import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let newDate: any;
    if(value){
     newDate= new Date(value);
    }else{
      newDate=new Date();
    }
    let dateArray = newDate.toString().split(' ');
    let formattedDate;
    if (args == undefined || args.toLowerCase() == "dt") {
      let today = new Date();
      let yesterday = new Date(Date.now() - 86400000);
      if (newDate.toDateString() == today.toDateString()) {
        formattedDate = "Today";
      } else if (newDate.toDateString() == yesterday.toDateString()) {
        formattedDate = "Yesterday";
      } else {
        formattedDate = dateArray[2] + " " + dateArray[1] + " " + dateArray[3];
      }
        formattedDate += ", " + this.time12Hr(dateArray[4]);
    } else if (args.toLowerCase() == 'fd') {
      formattedDate = dateArray[2] + " " + dateArray[1] + " " + dateArray[3];
    } else if (args.toLowerCase() == 'my') {
      formattedDate = dateArray[1] + " " + dateArray[3];
    } else if (args.toLowerCase() == 'od') {
      formattedDate = this.ordinalDate(dateArray[2]) + " " + dateArray[1];
    }

    return formattedDate;
  }

  /**
   * 
   * @param time --string for hh:mm:ss
   */
  time12Hr(time) {
    let amOrpm;
    time = time.split(':');
    if (time[0] >= 12) {
      if (time[0] > 12) {
        time[0] = time[0] % 12;
      }
      amOrpm = "pm";
    } else {
      amOrpm = "am";
    }
    return time[0] + ":" + time[1] + amOrpm;
  }
  
  ordinalDate(date) {
    if (date == 1 || date == 21 || date == 31) {
      date = date + 'st';
    } else if (date == 2 || date == 22) {
      date = date + 'nd';
    } else if (date == 3 || date == 23) {
      date = date + 'rd';
    } else {
      date = date + 'th';
    }
    return date;
  }
}
